module.exports = __webpack_public_path__ + "static/img/done.30253f26.svg";